import api from "@/api/users";

export default {
  state: {},
  mutations: {},
  actions: {
    async showUsers() {
      try {
        const res = await api.show();
        return res;
      } catch (error) {
        throw error;
      }
    },
    async showUsersAll(context) {
      try {
        const param = {
          account_id: await context.dispatch("showAccountID"),
        }
        const res = await api.showAll(param);
        return res.data;
      } catch (error) {
        throw error;
      }
    },
    async showDetailUsers(context) {
      try {
        const param = {
          account_id: await context.dispatch("showAccountID"),
        }
        const res = await api.showDetail(param);
        return res.data;
      } catch (error) {
        throw error;
      }
    },
  },
  getters: {},
};
